  <template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <h2 class="mt-5">{{$t('message.Test_results')}}</h2>
        <div class="d-flex">
          <div class="w-25" style="margin-left: 70px">
            <label>{{$t('message.Positions')}}</label>
            <b-form-select
                v-model="form.position_id"
                :options="positions"
                text-field="name_uz"
                value-field="id"
                class="form-select d-flex"
                @input="fetchTestResults"
                aria-label="Default select example"></b-form-select>
          </div>
          <div>
            <b-button variant="warning" class="mt-xl-4 ms-3" @click="refreshFilter">
              <i class="bx bx-sync font-size-18"></i>
            </b-button>
          </div>
        </div>
        <div>
          <b-card class="card mt-5" style=" width: 90%; margin: 0 auto">
          <b-table
              responsive
              striped
              hover
              :items="applications"
              :fields="fields">
          <template #cell(action)="data">
            <div>
              <b-button
                  @click="handlePush(data.item.id)"
                  style="background-color: #185d89"
                  variant="primary"
                  size="md">
                <i class="bx bx-show-alt font-size-18"></i>
              </b-button>
            </div>
          </template>
        </b-table>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SideBar from "../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import {getTestResults} from "../../../../../../api/tests";
import HorizontalTopbarInside from "../../../../../../components/horizontal-topbar-inside";
import {getPositions} from "../../../../../../api/directories";


export default {
  name: "TestResults",
  components: {
    HorizontalTopbarInside, SideBar
  },
  data() {
    return {
      isMenuCondensed: false,
      fields: [
        {key:"no",label: '№'},
        {key: "vacancy.position.name", label: this.$t('message.Positions')},
        {key: "full_name", label: this.$t('message.FullName')},
        {key: "region.nameuz", label: this.$t('message.Province')},
        {key: "rayon.nameuz", label: this.$t('message.Rayon')},
        {key:"cur_status.name", label:this.$t('message.Status')},
        {key: "action", label: this.$t('message.Action')},
      ],
      selected: null,
      positions:[],
      applications: [],
      form:{
        position_id : null,
      },
    };
  },
  computed: {
    ...layoutComputed,
  },
  created() {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchTestResults();
    this.fetchPositions()
  },
  methods: {
    fetchTestResults() {
      getTestResults({...this.$route.params, ...{position_id: this.form.position_id}}).then(res => {
        this.applications = res.data.data.data;
        this.applications.forEach((item, index) => {
          item.no = index+1;
          item.full_name = `${item.last_name} ${item.first_name}`
        })
      })
    },
    refreshFilter() {
      this.form.position_id = null;
      this.fetchTestResults();
    },
    fetchPositions(){
      getPositions().then(response => {
        this.positions = response.data.data
      })
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    handlePush(id){
      this.$router.push({name:'test-result-action',params:{id}})
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #4d63cf;
}


</style>



